import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from './../../components/EditableInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';

import { getPaidSubscribeData, updatePaidSubscribe } from '../../services/paidSubscribes';
import { showAlert } from '../../store/ducks/alert';

import { Button, CircularProgress } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const PaidSubscribesInformation = props => {
  const dispatch = useDispatch();
  const [paidSubscribe, setPaidSubscribe] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayPaidSubscribe();
  }, []);

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updatePaidSubscribe(paidSubscribe.id, paidSubscribe);
      dispatch(showAlert('success', 'Paid Subscribe has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Short. 😔'));
      console.log(error);
    }
  };

  const displayPaidSubscribe = async () => {
    const paidSubscribeId = props.match.params.id;
    try {
      setIsLoading(true);
      const { data } = await getPaidSubscribeData(0, { searchItem: 'id', search: paidSubscribeId });

      setPaidSubscribe(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this paidSubscribe. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Paid subscribe: {paidSubscribe.id}</h1>
      </div>

      <section className="update-section">
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput data={paidSubscribe} setData={setPaidSubscribe} labels={['paymentOriginToken']} />
            <EditableSelect data={paidSubscribe} setData={setPaidSubscribe} labels={['isActive']} />
            <UneditableInput data={paidSubscribe} labels={Object.keys(paidSubscribe)} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update Paid Subscribe
          </Button>
        </form>
      </section>
    </>
  );
};

export default PaidSubscribesInformation;
